import { LinkInterface } from 'atomic/link/link.interface';
import classNames from 'classnames';

import './link.scss';

export default function getLinkClasses(props: Pick<LinkInterface, 'block' | 'color' | 'uppercase' | 'size' | 'weight' | 'noWrap'>): string {
    const LinkClass = classNames({
        'link': true,
        [`link--${props.size}`]: true,
        [`link--fw-${props.weight}`]: true,
        'link--block': props.block,
        'link--uppercase': props.uppercase,
        'link--nowrap': props.noWrap,
        [`link--color-${props.color}`]: Boolean(props.color)
    });

    return LinkClass;
}
